/**
 * Widget preset registry — all widget definitions live alongside this file.
 *
 * Preset definitions  : *.ts  files in this directory
 * React renderers     : *Widget.tsx files in this directory
 * Stickers            : stickers/*.svg, listed in stickers/stickers.json
 * Node shell/routing  : ../WidgetNode.tsx
 */

export type { WidgetPreset } from "./types";

import { DS_STICKER_PRESETS } from "./ds";
import { STICKER_PRESETS } from "./stickers";
import { TIMER_DIGITAL } from "./timer-digital";
import { VOTE } from "./vote";

import type { WidgetPreset } from "./types";

export const WIDGET_PRESETS: WidgetPreset[] = [
  TIMER_DIGITAL,
  VOTE,
  ...STICKER_PRESETS,
];

/** Lookup map for all widget presets, the design system's inventories
 * included — they render and drop everywhere but are listed only by the
 * redrawn tray (ROUND3 §3). */
export const WIDGET_ALL_PRESET_MAP = new Map<string, WidgetPreset>(
  [...WIDGET_PRESETS, ...DS_STICKER_PRESETS].map((p) => [p.id, p]),
);
